<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        <div class="headline font-weight-bold">Biscuit</div>
      </div>
      <v-spacer></v-spacer>
      <div>
        <v-layout align-center>
          <v-switch
            hide-details
            append-icon="mdi-weather-night"
            v-model="$vuetify.theme.dark"
            color="grey darken-2"
          ></v-switch>
        </v-layout>
      </div>
    </v-app-bar>
    <v-navigation-drawer
      app
      bottom
      v-model="drawer"
      :mini-variant.sync="mini"
      permanent
      v-if="authUser"
    >
      <v-list-item class="px-2">
        <v-list-item-avatar v-if="authUser">
          <v-img :src="authUser.photoURL" :lazy-src="authUser.photoURL"></v-img>
        </v-list-item-avatar>

        <v-list-item-title v-if="authUser" class="font-weight-medium">{{
          authUser.displayName
        }}</v-list-item-title>

        <v-btn icon @click.stop="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>
      <v-list dense>
        <v-list-item v-for="item in items" :key="item.title" :to="item.to">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block dark @click="signOut"> Logout </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-main>
      <router-view />
      <v-snackbar
        :color="color"
        v-model="snackbar"
        bottom
        multi-line
        :timeout="timeout"
        class="subtitle-2"
      >
        {{ text }}
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import { bus } from '../main';
import { mapState, mapActions } from 'vuex';
import { auth } from '@/plugins/firebase';
export default {
  name: 'App',
  components: {},

  data: () => ({
    drawer: true,
    items: [
      { title: 'Ingredients', icon: 'mdi-view-dashboard', to: '/' },
      { title: 'Scheduled', icon: 'mdi-timer-outline', to: '/scheduled' },
      {
        title: 'Review Entities',
        icon: 'mdi-text-box-check-outline',
        to: '/entity',
      },
      {
        title: 'Subscribers',
        icon: 'mdi-account-group-outline',
        to: '/subscribers',
      },
      {
        title: 'Profile Crawlers',
        icon: 'mdi-spider',
        to: '/profile-crawlers',
      },
      {
        title: 'Feeds',
        icon: 'mdi-rss',
        to: '/feeds',
      },
      {
        title: 'Push Notifications',
        icon: 'mdi-send',
        to: '/push-notifications',
      },
      {
        title: 'Gallery',
        icon: 'mdi-image-multiple-outline',
        to: '/assets',
      },
    ],
    mini: false,
    snackbar: false,
    text: '',
    timeout: 5000,
    color: '',
    // authUser: {
    //   displayName: "",
    //   photoURL: "",
    // },
  }),
  computed: {
    ...mapState('$_auth', ['authUser']),
  },
  created() {
    this.getCurrentUser();
    bus.$on('show-snackbar', (data) => {
      this.snackbar = true;
      this.text = data.text;
      this.color = data.color;
    });
  },
  methods: {
    ...mapActions({
      getCurrentUser: '$_auth/getCurrentUser',
    }),
    signOut() {
      this.$store.dispatch('$_auth/userSignOut').then(() => {
        this.$router.push('/sign-in');
      });
    },
  },
};
</script>
